import { FadeUp } from './FadeUp';
import { StaggerChildren } from './RevealAnimations';

const contrasts = [
  {
    before: '60 minutes',
    beforeContext: 'of manual research per lead',
    after: '6 seconds',
    afterContext: 'with AI doing the same work',
  },
  {
    before: 'Weeks',
    beforeContext: 'of domain warmup before sending',
    after: 'Instant',
    afterContext: 'send from your real Gmail today',
  },
  {
    before: '1 template',
    beforeContext: 'copy-pasted to 10,000 people',
    after: '1 unique email',
    afterContext: 'per lead, every single time',
  },
];

export function MetricsBar() {
  return (
    <FadeUp>
      <StaggerChildren
        className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5"
        staggerMs={120}
      >
        {contrasts.map((c) => (
          <div
            key={c.before}
            className="glass-card rounded-xl p-5 sm:p-6 space-y-4"
          >
            {/* Before (the old way) */}
            <div className="space-y-0.5">
              <p className="text-lg font-bold text-base-content/25 line-through decoration-base-content/15 decoration-2">
                {c.before}
              </p>
              <p className="text-xs text-base-content/25">{c.beforeContext}</p>
            </div>

            {/* After (the HyPeMa way) */}
            <div className="space-y-0.5">
              <p className="text-2xl sm:text-3xl font-extrabold tracking-tight text-gradient">
                {c.after}
              </p>
              <p className="text-sm text-base-content/60 font-medium">
                {c.afterContext}
              </p>
            </div>
          </div>
        ))}
      </StaggerChildren>
    </FadeUp>
  );
}
